module.exports = __webpack_public_path__ + "img/login_logo.17512c8f.png";